import { CmsCategoryHighlightBlockLoadable } from './CmsCategoryHighlightBlockLoadable';

import type { CmsApiCategoryHighlightBlockData } from '#/modules/cms/api/types/blocks/CmsApiCategoryHighlightBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

export const CmsCategoryHighlightBlockMapping: CmsBlockMapping<CmsApiCategoryHighlightBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsCategoryHighlightBlockLoadable,
  };
